import React, { memo, useEffect, useState } from "react";
import {
	Row, Col,
	Card, CardHeader, CardTitle, CardBody
} from "reactstrap";

const ChromeCheck = (props) => {

	const [mic, setMic] = useState(false);

	useEffect(() => {
		navigator.getUserMedia({ audio: true }, () => {
          setMic(true); // mic found.

        }, () => {
          setMic(false); // not found.

        });
	}, []);

	const checkResources = (status) => {
		setTimeout(() => {
			// open check resources page
			props.setStep(2); // do no change this no.
		}, 1000);
	};	

	let chrome = /Chrome/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
	if (chrome && mic) {
		checkResources(true);
	}

	return (
		<div className="content">
			<Row>
				<Col xs={12}>
					<Card>
						<CardHeader>
							<CardTitle tag="h4">Chrome browser</CardTitle>
						</CardHeader>
						<CardBody className="text-center">
							{chrome &&
								<i
									className="fa fa-check-circle"
									style={{
										color: 'green',
										fontSize: '100px'
									}}
								></i>
							}
							
							{!chrome &&
								<React.Fragment> 
									<i
										className="fa fa-times-circle"
										style={{
											color: 'red',
											fontSize: '100px'
										}}
									></i>
									<br />
									<em>*Please open chrome browser for practice question(s)</em>
								</React.Fragment>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>

			<Row>
				<Col xs={12}>
					<Card>
						<CardHeader>
							<CardTitle tag="h4">Microphone</CardTitle>
						</CardHeader>
						<CardBody className="text-center">
							{mic &&
								<i
									className="fa fa-check-circle"
									style={{
										color: 'green',
										fontSize: '100px'
									}}
								></i>
							}
							
							{!mic &&
								<React.Fragment> 
									<i
										className="fa fa-times-circle"
										style={{
											color: 'red',
											fontSize: '100px'
										}}
									></i>
									<br />
									<em>*Please attach microphone to your system and refresh page.</em>
								</React.Fragment>
							}
						</CardBody>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default ChromeCheck;